export default {
  namespaced: true,
  state: {
    analysisId: '',//分析id
    analysisStep: '',//当前分析步骤
    analysisData: {//特征分析
      columnParam: [],//自变量
      variable: "",//因变量
      docId: "",//文件id
      docData: {}
    },
    dmId: "",//模型id
    dmObj: {},//模型对象
  },
  mutations: {
    setAnalysisId (state, data) {
      state.analysisId = data
    },
    setAnalysisData (state, data) {
      state.analysisData = data
    },
    setDmId (state, data) {
      state.dmId = data
    },
    setDmObj (state, data) {
      state.dmObj = data
    },
    setAnalysisStep (state, data) {
      state.analysisStep = data
    },
  },
  getters: {},
}



// WEBPACK FOOTER //
// ./src/store/analysis.js